/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EStatutDemande } from './EStatutDemande';
import {
    EStatutDemandeFromJSON,
    EStatutDemandeFromJSONTyped,
    EStatutDemandeToJSON,
} from './EStatutDemande';

/**
 * 
 * @export
 * @interface EListSearchTypeEStatutDemandeCombinableCriteria
 */
export interface EListSearchTypeEStatutDemandeCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeEStatutDemandeCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EStatutDemande}
     * @memberof EListSearchTypeEStatutDemandeCombinableCriteria
     */
    value?: EStatutDemande;
    /**
     * 
     * @type {EStatutDemande}
     * @memberof EListSearchTypeEStatutDemandeCombinableCriteria
     */
    secondaryValue?: EStatutDemande;
}

/**
 * Check if a given object implements the EListSearchTypeEStatutDemandeCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeEStatutDemandeCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeEStatutDemandeCombinableCriteriaFromJSON(json: any): EListSearchTypeEStatutDemandeCombinableCriteria {
    return EListSearchTypeEStatutDemandeCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeEStatutDemandeCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeEStatutDemandeCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EStatutDemandeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EStatutDemandeFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeEStatutDemandeCombinableCriteriaToJSON(value?: EListSearchTypeEStatutDemandeCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EStatutDemandeToJSON(value.value),
        'secondaryValue': EStatutDemandeToJSON(value.secondaryValue),
    };
}

